import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import "./globals.css";
import { AppProviders } from "./providers.js";
import { AppRouter } from "./router.js";
import { ErrorBoundary } from "@/shared/ui/ErrorBoundary.js";
import { Toaster } from "@/shared/ui/sonner.js";

// Registra el service worker; con autoUpdate, se recarga en background automáticamente.
registerSW({ immediate: true });

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("[main] Root element #root not found in the DOM");
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <AppProviders>
        <AppRouter />
        <Toaster />
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>,
);
